import React, { useState } from "react";
import PropTypes from "prop-types";
import { Sidebar } from "../design-system/layout/Sidebar";
import { Topbar } from "../design-system/layout/Topbar";
import { useIsMobile } from "../design-system";
import ImpersonationBanner from "../Components/ImpersonationBanner";

/**
 * Shell de aplicación Kronaly DS v1.
 *
 * Desktop (>=768px): Sidebar 248px fijo a la izquierda + main scrollable.
 * Mobile (<768px):   Sidebar como slide-over controlado por el hamburger
 *                    del Topbar; main ocupa todo el ancho.
 */
const Layout = ({ children }) => {
  const isMobile = useIsMobile();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <div className="kr-app">
      <Sidebar
        mobileOpen={isMobile ? mobileNavOpen : false}
        onMobileClose={() => setMobileNavOpen(false)}
      />
      <div className="kr-app-main">
        <ImpersonationBanner />
        <Topbar
          showHamburger={isMobile}
          onOpenMobileNav={() => setMobileNavOpen(true)}
        />
        <main className="kr-app-content">{children}</main>
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
